import React from 'react';
import './CardMedia.scss';
import './CardMedia-media.scss';
import { ICardMedia } from './interfaces';

const CardMedia = ({ image, title, link }: ICardMedia) => {
  return (
    <a href={link} target="_blank" className="card-media" rel="nofollow">
      {image ? (
        <img src={image} className="card-media__image" alt="" />
      ) : (
        <div className="card-media__image"></div>
      )}
      <h4 className="card-media__title">{title}</h4>
    </a>
  );
};

export default CardMedia;
